import { render } from "./Feed.vue?vue&type=template&id=582c974f"
import script from "./Feed.vue?vue&type=script&lang=js"
export * from "./Feed.vue?vue&type=script&lang=js"
script.render = render

export default script